import React from 'react';
import './App.css';

//components
import Slider from './components/slider'
import Header from './components/header'
import About from './components/about'
import Missions from './components/missions'
import Socmed from './components/socmed'
import Footer from './components/footer'

function App() {
  return (
    <div className="App">
      <Header/>
      <Slider/>
      <About/>
      <Missions/>
      <Socmed/>
      <Footer/>
    </div>
  );
}

export default App;
